<h1 mat-dialog-title>Buscar Participante
    <mat-divider></mat-divider>
</h1>
<div mat-dialog-content>
    <form action="" [formGroup]="bsqAsistenteForm" autocomplete="off" novalidate (ngSubmit)="buscarParticipante(bsqAsistenteForm.value)" class="mb-3">
        <div class="row justify-content-start">
            <mat-label class="col-sm-3 col-form-label">Nro. Documento:</mat-label>
            <mat-form-field class="col-md-4 col-sm-12" appearance="outline">
                <input matInput placeholder="" formControlName="numeroDocumento" id="numeroDocumento" maxlength="13" (change)="limpiarCamposTipoBsq('numeroDocumento')"
                maxlength="13" (keypress) = "fnKeyDownAlphaNumeric($event)" (keyup) = "fnAlphaNumericMobile($event)" (input)="fnInputMaxLength($event);">
                <mat-error *ngIf="hasErrorForm('numeroDocumento')">{{getErrorForm('numeroDocumento')}}</mat-error>
           </mat-form-field>
        </div>
        <div class="row justify-content-start">
            <mat-label class="col-sm-3 col-form-label">Nombres y Apellidos:</mat-label>
            <mat-form-field class="col-md-6 col-sm-12" appearance="outline">
                <input matInput placeholder="Nombres completos" name="nombresCompletos" formControlName="nombresCompletos" maxlength="40" (change)="limpiarCamposTipoBsq('nombresCompletos')">
                <mat-error *ngIf="hasErrorForm('nombresCompletos')">{{getErrorForm('nombresCompletos')}}</mat-error>
            </mat-form-field>
            <div class="col-md-3 col-sm-12  text-right mb-1">
                <button class="btn-block" mat-raised-button color="primary" [disabled]="this.bsqAsistenteForm.invalid" matSuffix   aria-label="Clear" 
                    type="submit">
                    <mat-icon>search</mat-icon>
                    Buscar
                </button>
            </div>
        </div>
    </form>
    <div class="mat-elevation-z4">
        <div class="example-container">
            <table mat-table [dataSource]="dataSource" aria-describedby="tabla registro de asistentes">
                    <!-- Checkbox Column -->
              <ng-container matColumnDef="CHECK" sticky>
                <th mat-header-cell *matHeaderCellDef scope="col">
                  <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                  </mat-checkbox> 
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
              </ng-container>
                    
              <!-- nombres Column -->
              <ng-container matColumnDef="TIPO">
                <th mat-header-cell *matHeaderCellDef scope="col"> TIPO </th>
                <td mat-cell *matCellDef="let element" class="text-center">{{element.descTipoParticipante}}</td>
              </ng-container>

              <!-- NUMERODOCUMENTO Column -->
              <ng-container matColumnDef="NUMERODOCUMENTO" >
                <th mat-header-cell *matHeaderCellDef scope="col"> NRO. DOCUMENTO </th>
                <td mat-cell *matCellDef="let element" class="text-center">{{element.numeroDocumento}} </td>
              </ng-container>

              <!-- NUMERODOCUMENTO Column -->
              <ng-container matColumnDef="NOMBRESCOMPLETOS" >
                <th mat-header-cell *matHeaderCellDef scope="col"> PARTICIPANTE </th>
                <td mat-cell *matCellDef="let element" class="text-center">{{element.nombreCompleto}}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    (click)="selection.toggle(row)">
              </tr>
            </table>
          </div>
          <div *ngIf="dataSource.data.length === 0" class="text-center text-secondary p-3">
                <span>No se encontraron resultados</span>
          </div>
          <mat-divider></mat-divider>
          <mat-paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
    
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions class="d-flex justify-content-end">
    <button mat-raised-button (click)="closeConfirmDialog()" cdkFocusInitial>Cerrar</button>
    <button mat-raised-button (click)="seleccionarAsistentes()" cdkFocusInitial color="primary" [disabled]="selection.selected.length == 0">Seleccionar</button>
</div>